import styled from 'styled-components';

const AlertPanel = styled.div`
    z-index: 1;
    pointer-events: none;
    background-color: transparent;
    padding: 8px 8px 8px 8px;
    grid-column: controls-end / instrument-start;
    grid-row: alert-bar-top / alert-bar-bottom;

    /* Allow pointer events only on child elements */
    & > * {
        pointer-events: all;
    }
`;

export default AlertPanel;
